import { c as _c } from "react/compiler-runtime";
import { TEST_IDS } from '@repo/sdk/constants';
import { Field, FieldError, Select, SelectContent, SelectItem, SelectTrigger, SelectValue, selectVariant, Spinner } from '@repo/ui/components';
import { cn, VariantProps } from '@repo/ui/lib/utils';
import { ReadOnlyTooltip, useReadOnly } from '../../components/readonly.tsx';
import { useFieldContext } from '../../lib/form-context.ts';
const CONTACT_TYPES = [{
  label: 'Primary',
  value: 'primary'
}, {
  label: 'Secondary',
  value: 'secondary'
}, {
  label: 'Transport',
  value: 'transport'
}, {
  label: 'Accounts',
  value: 'accounts'
}] as const;
export const FormContactTypeSelect = t0 => {
  const $ = _c(39);
  const {
    compact: t1,
    "data-testid": dataTestId,
    disabled: t2,
    disabledTypes: t3,
    hideChevron: t4,
    isPending: t5,
    placeholder: t6,
    variant: t7
  } = t0;
  const compact = t1 === undefined ? false : t1;
  const disabled = t2 === undefined ? false : t2;
  let t8;
  if ($[0] !== t3) {
    t8 = t3 === undefined ? [] : t3;
    $[0] = t3;
    $[1] = t8;
  } else {
    t8 = $[1];
  }
  const disabledTypes = t8;
  const hideChevron = t4 === undefined ? false : t4;
  const isPending = t5 === undefined ? false : t5;
  const placeholder = t6 === undefined ? "-" : t6;
  const variant = t7 === undefined ? "default" : t7;
  const field = useFieldContext();
  let t9;
  if ($[2] !== field.state.meta.errors) {
    t9 = field.state.meta.errors ?? [];
    $[2] = field.state.meta.errors;
    $[3] = t9;
  } else {
    t9 = $[3];
  }
  const errors = t9;
  const isReadOnly = useReadOnly();
  if (isReadOnly) {
    let t10;
    if ($[4] !== field.state.value) {
      t10 = CONTACT_TYPES.find(type => type.value === field.state.value)?.label ?? "-";
      $[4] = field.state.value;
      $[5] = t10;
    } else {
      t10 = $[5];
    }
    let t11;
    if ($[6] !== t10) {
      t11 = <ReadOnlyTooltip>{t10}</ReadOnlyTooltip>;
      $[6] = t10;
      $[7] = t11;
    } else {
      t11 = $[7];
    }
    return t11;
  }
  const t10 = isPending || disabled;
  let t11;
  if ($[8] !== field) {
    t11 = val => field.handleChange(val);
    $[8] = field;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  const t12 = field.state.value;
  const t13 = compact && "flex justify-between gap-2 p-0 text-base data-[size=default]:h-6";
  let t14;
  if ($[10] !== t13) {
    t14 = cn("w-full", t13);
    $[10] = t13;
    $[11] = t14;
  } else {
    t14 = $[11];
  }
  let t15;
  if ($[12] !== placeholder) {
    t15 = <SelectValue placeholder={placeholder} data-sentry-element="SelectValue" data-sentry-source-file="form-contact-type-select.tsx" />;
    $[12] = placeholder;
    $[13] = t15;
  } else {
    t15 = $[13];
  }
  let t16;
  if ($[14] !== isPending) {
    t16 = isPending && <Spinner className="text-muted-foreground ml-auto size-4" />;
    $[14] = isPending;
    $[15] = t16;
  } else {
    t16 = $[15];
  }
  let t17;
  if ($[16] !== dataTestId || $[17] !== field.name || $[18] !== hideChevron || $[19] !== t14 || $[20] !== t15 || $[21] !== t16 || $[22] !== variant) {
    t17 = <SelectTrigger className={t14} data-testid={dataTestId} hideChevron={hideChevron} id={field.name} variant={variant} data-sentry-element="SelectTrigger" data-sentry-source-file="form-contact-type-select.tsx">{t15}{t16}</SelectTrigger>;
    $[16] = dataTestId;
    $[17] = field.name;
    $[18] = hideChevron;
    $[19] = t14;
    $[20] = t15;
    $[21] = t16;
    $[22] = variant;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] !== disabledTypes) {
    t18 = CONTACT_TYPES.map(type_0 => {
      const isDisabled = disabledTypes.includes(type_0.value);
      return <SelectItem data-testid={TEST_IDS.contact.form.typeOption(type_0.value)} disabled={isDisabled} key={type_0.value} value={type_0.value}>{type_0.label}{isDisabled && " (already exists)"}</SelectItem>;
    });
    $[24] = disabledTypes;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  let t19;
  if ($[26] !== t18) {
    t19 = <SelectContent data-sentry-element="SelectContent" data-sentry-source-file="form-contact-type-select.tsx">{t18}</SelectContent>;
    $[26] = t18;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  let t20;
  if ($[28] !== field.state.value || $[29] !== t10 || $[30] !== t11 || $[31] !== t17 || $[32] !== t19) {
    t20 = <div className="relative"><Select disabled={t10} items={CONTACT_TYPES} onValueChange={t11} value={t12} data-sentry-element="Select" data-sentry-source-file="form-contact-type-select.tsx">{t17}{t19}</Select></div>;
    $[28] = field.state.value;
    $[29] = t10;
    $[30] = t11;
    $[31] = t17;
    $[32] = t19;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== errors) {
    t21 = <FieldError className="text-sm" errors={errors} data-sentry-element="FieldError" data-sentry-source-file="form-contact-type-select.tsx" />;
    $[34] = errors;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  let t22;
  if ($[36] !== t20 || $[37] !== t21) {
    t22 = <Field className="gap-1" data-sentry-element="Field" data-sentry-component="FormContactTypeSelect" data-sentry-source-file="form-contact-type-select.tsx">{t20}{t21}</Field>;
    $[36] = t20;
    $[37] = t21;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  return t22;
};